import React from "react";
import { Form, Input } from "antd";
import "./FormItem.scss";

const FormItemInput = ({
  label,
  name,
  placeholder,
  rules = [],
  disabled = false,
  maxLength,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <Input
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
    </Form.Item>
  );
};

export default FormItemInput;
